export const portalColors = {
  primary: '#1a1a1a',
  secondary: '#6b7280',
  muted: '#9CA3AF',
  veryMuted: '#D1D5DB',
  divider: '#E5E7EB',
  subtleDivider: '#F3F4F6',
  background: '#F7F8FA',
  card: '#FFFFFF',
  defaultAccent: '#0F6CBD',
  completedDot: '#0F6CBD',
  upcomingDot: '#93C5FD',
};

export const portalShadow = {
  card: '0 4px 16px rgba(0,0,0,0.08)',
  subtle: '0 2px 8px rgba(0,0,0,0.06)',
};

export const portalRadius = {
  card: 16,
  button: 12,
  checkbox: 6,
  pill: 20,
  tab: 10,
  calDay: 10,
};
